<div class="radios-container" [formGroup]="form">
  <p>{{ Texts.currency }}</p>
  <mat-radio-group
    aria-label="Select an option"
    formControlName="typeOfCurrency"
    (change)="onTypeOfCurrencyChange()"
  >
    <div class="options">
      <mat-radio-button class="primary-radiobutton" value="bs"
        >{{ Texts.bsd }}
      </mat-radio-button>
      <mat-radio-button class="primary-radiobutton" value="other"
        >{{ Texts.other }}
      </mat-radio-button>
    </div>
  </mat-radio-group>

  <ng-container *ngIf="isOtherCurrency">
    <mat-form-field appearance="outline">
      <mat-label>Monedas</mat-label>
      <mat-select formControlName="currency">
        <mat-option *ngFor="let curren of currency" [value]="curren">
          {{ curren }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
</div>
